export const educationData = [
    {
        id: 1,
        institution: 'Indian Institute of Information Technology Pune',
        course: 'B.Tech CSE',
        CGPA:'8.83',
        startYear: '2022',
        endYear: '2026',
    },

]